<template>
  <div>
    <flight-bookings-list
      v-for="section in visibleSections"
      :key="section.title"
      :title="section.title"
      :filters="section.filters"
      :hide-empty="section.hideEmpty"
      :page-size="10"
    />
  </div>
</template>

<script>
import FlightBookingsList from './List.vue'

const sections = [
  { title: 'Provisional Requests', filters: { booking_mode: 'manual', request_status: 'provisional', provider_status: 'new' } },
  { title: 'Awaiting Sales Decision', filters: { booking_mode: 'manual', request_status: 'provisional', provider_status: 'booked_provisionally' } },
  { title: 'Book Requests', filters: { booking_mode: 'manual', request_status: 'book', provider_status: 'new,booked_provisionally' } },
  { title: 'Prepare & Confirm', filters: { booking_mode: 'aerocrs', status: 'held' } },
  { title: 'Ticketing', filters: { status: 'confirmed' } },
  { title: 'Ticketed', filters: { status: 'ticketed' } },
  { title: 'Not Available', filters: { status: 'not_available' } }
]

export default {
  name: 'FlightBookingsActive',
  components: { FlightBookingsList },
  props: {
    filters: { type: Object, default: () => ({}) }
  },
  computed: {
    visibleSections() {
      return sections
        .filter(section => !this.filters.booking_mode || !section.filters.booking_mode || section.filters.booking_mode === this.filters.booking_mode)
        .map(section => ({
          ...section,
          hideEmpty: section.title !== 'Ticketed',
          filters: { ...this.filters, ...section.filters, category: 'upcoming', status_exclude: 'cancelled' }
        }))
    }
  }
}
</script>
